<template>
    <div class="pageMessage">
        <div class="chat" style="padding-bottom:3rem;">
            <van-pull-refresh v-model="isLoading" @refresh="onLoadMoreHistory">
                <div v-for="(item, key) in msgList" :key="key">
                    <div class="item tradesman" v-if="mine.userId == item.from">
                        <div class="item_time">{{ formateDate(item.time) }}</div>
                        <div class="item_info clearfix">
                            <img :src="userThumb" alt="" class="touxiang f-r" />
                            <!-- <div class="xiaoxi f-r">{{ item.data }}</div> -->
                            <div class="f-r" v-html="isdingzhi(item)"></div>
                        </div>
                        <div v-if="item.isTodayFirst" class="item_attention">欢迎光临小店，匠人正在尽快赶来······</div>
                    </div>
                    <div class="item user" v-if="mine.userId == item.to">
                        <div class="item_time">{{ formateDate(item.time) }}</div>
                        <div class="item_info clearfix">
                            <img :src="tradesmanInfo.tradesmans != null ? tradesmanInfo.tradesmans.thumb : tradesmanInfo.userdata.thumb" alt="" class="touxiang f-l" />
                            <div class="f-l" v-html="isdingzhi(item)"></div>
                        </div>
                    </div>
                </div>
            </van-pull-refresh>
        </div>
        <!-- 定制按钮 -->
        <div class="dingzhi_btns" v-if="userRole.is_tradesman">
            <div class="btn" @click="sendDingzhiForm">定制</div>
            <div class="btn bigsize" @click="selectTradesmanDingzhi">我的定制</div>
            <!-- <div class="btn bigsize" @click="sendTradesmanDingzhi" v-if="tradesmanDingzhi_id">发送我选择的定制品</div> -->
        </div>
        <!--  -->
        <div class="fix_bottom_chat_form">
			<!-- 20201218前,先保留,后续没问题再删 -->
            <!-- <van-uploader class="chat_send f-r" :after-read="onRead"><img :src="publicPath + 'statics/images/icon_sendimage.png'" /></van-uploader>
            <button class="chat_send f-r" @click="sendMsg"><img :src="publicPath + 'statics/images/icon_sendmsg.png'" /></button>
            <input type="text" class="chat_input" placeholder="在这里输入消息内容～" v-model="msg" /> -->
			<div class="chat_form_l">
				<a class="telwrap" :href="'tel:' + transmanPhone" v-if="transmanPhone && !userRole.is_tradesman"><img :src="publicPath + 'statics/images/icon_tel.png'" class="telbg"></a>
				<div class="chat_wrap">
					<input type="text" class="chatinput" placeholder="在这里输入消息内容～" v-model="msg" />
					<span class="sendmsg" @click="sendMsg">发送</span>
				</div>
			</div>
			<van-uploader class="chatsend" :after-read="onRead"><img :src="publicPath + 'statics/images/icon_sendimage.png'" /></van-uploader>
        </div>
    </div>
</template>

<script>
import router from '../../../.././router';
import { LOGOUT, LOGIN } from '../../../.././vuex/mutation_types';
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js';
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            mine: null, // 自己的信息
            mineUUID: null,
            uuid: null, // 匠人uuid
            tradesmanInfo: null, // 匠人环信信息
            userThumb: null, // 用户头像
            msg: '', // 发送消息
            msgList: [], // 消息列表
            isLoading: false,
            dingzhiId: this.$route.query.dingzhiId,
            userRole: {
                is_tradesman: false
            }, // 用户的角色
            tradesmanDingzhi: null, // 已选的定制
			msgImage: null,
			transmanPhone: null, // 匠人的电话
            isSendingMessage: false
        };
    },
    watch: {
        '$parent.getTextMsg': function(newval, oldval) {
            console.log('监听到环信新消息', oldval, newval);
            var that = this;
            if (newval != null) {
                if (newval.from != this.tradesmanInfo.im_username) {
                    return;
                }
                var list = that.msgList;
                list.push(newval);
                that.msgList = list;
                that.setTodayFirstMessage()
                localStorage.setItem('msgHistory', JSON.stringify(list));
                setTimeout(function() {
                    $(window).scrollTop($('body').height());
                    that.msg = '';
                }, 100);
                that.$parent.getTextMsg = null;
            }
        }
    },
    beforeMount() {
        // 清除消息缓存
        this.$publicData.webimconn.mr_cache = [];
        localStorage.setItem('msgHistory', JSON.stringify([]));
    },
    created: function() {
        // 清除消息缓存
        this.$publicData.webimconn.mr_cache = [];
        // 获取匠人信息
        this.uuid = this.$route.query.uuid;
        this.mine = JSON.parse(localStorage.getItem('userInfo'));

        var that = this;
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //此页面App使用原生
        }
        that.userThumb = localStorage.getItem('thumb'); // 用户图像
        that.getData(function() {
            // 发送商家选中的定制品
            that.sendTradesmanDingzhi();
        });
        // this.easemobchantcreate();
        that.getUserInfo();

        // 已选的定制
        // console.log('已选的定制',localStorage.getItem('dingzhi_id'))
        // that.tradesmanDingzhi_id = localStorage.getItem('dingzhi_id')
        // localStorage.removeItem('dingzhi_id')

        // that.tradesmanDingzhi = JSON.parse(localStorage.getItem('tradesmanDingzhi'))
        // console.log('已选的定制',that.tradesmanDingzhi)
        // localStorage.removeItem('tradesmanDingzhi')
        // if(that.tradesmanDingzhi){
        // 	that.sendTradesmanDingzhi()
        // }
    },
    mounted: function () {
        var logout = this.$publicData.isIMLogout
        if (logout) {
            this.$toast('您的聊天账号已在其他地方登录，请刷新页面');
        }
    },
    methods: {
        // 创建/更新匠人聊天关联
        easemobchantcreate() {
            this.$api.xiaoxi
                .easemobchantcreate({
                    token: this.$store.getters.token,
                    to_uuid: this.uuid
                })
                .then(res => {
                    if (res.code == 500) {
                        this.$parent.sendMsgToTradesman('与' + this.tradesmanInfo.username + '建立了通信', this.mine.userId, this.tradesmanInfo.im_username);
                    }
                });
        },
        // 获取列表
        getData(callback) {
            var that = this;
            // iframe 获取用户环信信息
            // that.$parent.getWebIMInfo();
            // 获取匠人环信信息；
            var params = {
                token: that.$store.getters.token,
                uuid: that.uuid
            };
            that.$api.xiaoxi.userInfo(params).then(res => {
                if (res.code == 200) {
                    that.tradesmanInfo = res.result;
                    if (that.tradesmanInfo.im_username == that.mine.userId) {
                        that.$toast('不能和自己聊天');
                    } else {
                        // this.easemobchantcreate();
						// 匠人的电话
						that.transmanPhone = res.result.tradesmans?res.result.tradesmans.data.phone:null
                        window.document.title =
                            that.tradesmanInfo.tradesmans != null
                                ? that.tradesmanInfo.tradesmans.nickname
                                : that.tradesmanInfo.userdata.nickname != null
                                ? that.tradesmanInfo.userdata.nickname
                                : that.tradesmanInfo.username;
                        // console.log('创建了与匠人的通信')
                        // that.$parent.sendMsgToTradesman('与' + that.tradesmanInfo.username + '建立了通信', that.mine.userId, that.tradesmanInfo.im_username);

                        that.getHistory();
                        // setInterval(function() {
                        //     that.getHistory();
                        // },5000)
                    }

                    that.tradesmanDingzhi = JSON.parse(localStorage.getItem('tradesmanDingzhi'));
                    localStorage.removeItem('tradesmanDingzhi');
                    if (that.tradesmanDingzhi) {
                        // that.sendTradesmanDingzhi()
                        callback();
                    }
                }
            });
        },
        // 上传图片
        onRead: function(file) {
            
            var that = this;
            if ($.isArray(file)) {
                for (var i in file) {
                    this.$api.index
                        .uploadImage({
                            imgFile: file[i].content
                        })
                        .then(res => {
                            if (res.code == 200) {
                                that.sendImageMsg(res.result.url);
                            }
                        });

                    // this.$api.index.uploadImage({
                    //     imgFile: file[i].content
                    // }).then(res => {
                    //     if (res.code == 200) {
                    //         this.imglist.push(res.result.url);
                    //     }
                    // });
                }
            } else {
                this.$api.index
                    .uploadImage({
                        imgFile: file.content
                    })
                    .then(res => {
                        if (res.code == 200) {
                            that.sendImageMsg(res.result.url);
                        }
                    });
                // var imgFile = this.base64to2(file.content);
                // console.log('imgFile:',imgFile)
                // this.sendImageMsg(imgFile)
                // this.sendImageMsg(file)
                // this.$api.index.uploadImage({
                //     imgFile: file.content
                // }).then(res => {
                //     if (res.code == 200) {
                //         this.imglist.push(res.result.url);
                //     }
                // });
            }
        },
        sendImageMsg(imgUrl) {
            var that = this;
            that.$parent.sendImageToTradesman(imgUrl, that.mine.userId, that.tradesmanInfo.im_username, function() {
                var list = that.msgList;
                list.push({
                    from: that.mine.userId,
                    to: that.tradesmanInfo.im_username,
                    type: 'chat',
                    url: '//a1.easemob.com' + imgUrl,
                    width: 100,
                    height:100,
                    contentsType: "IMAGE",
                    time: new Date().getTime().toString()
                });
                that.msgList = list;
                that.setTodayFirstMessage()
                localStorage.setItem('msgHistory', JSON.stringify(list));
                that.$parent.updateHistoryList({ to_user: that.tradesmanInfo.im_username, time: new Date().getTime() });
                that.easemobchantcreate();
                setTimeout(function() {
                    $(window).scrollTop($('body').height());
                    that.msg = '';
                }, 100);
            });
        },
        // 发送消息
        sendMsg(message) {
            var that = this;
            if (that.tradesmanInfo.im_username == that.mine.userId) {
                that.$toast('不能和自己聊天');
                return;
            }
            // that.msg = JSON.stringify(that.msg);
            var sendMsg = that.msg;
            if (typeof message == 'string') {
                sendMsg = message;
            }
            if (sendMsg == null || sendMsg == undefined) {
                return;
            }
            if (this.isSendingMessage == true) {
                return
            }
            if (sendMsg.replace(/^\s+|\s+$/g, '') == '') {
                // that.$toast('不能发送空消息');
                return;
            }
            this.isSendingMessage = true
            sendMsg = sendMsg.replace('<','&lt')
            sendMsg = sendMsg.replace('>','&gt')
            // return;
            that.$parent.sendMsgToTradesman(sendMsg, that.mine.userId, that.tradesmanInfo.im_username, function() {
                var list = that.msgList;
                list.push({
                    from: that.mine.userId,
                    to: that.tradesmanInfo.im_username,
                    data: sendMsg,
                    sourceMsg: sendMsg,
                    contentsType: 'TEXT',
                    time: new Date().getTime().toString()
                });
                
                that.msgList = list;
                that.setTodayFirstMessage()
                localStorage.setItem('msgHistory', JSON.stringify(list));
                that.$parent.updateHistoryList({ to_user: that.tradesmanInfo.im_username, time: new Date().getTime() });
                that.easemobchantcreate();
                setTimeout(function() {
                    $(window).scrollTop($('body').height());
                    that.msg = '';
                    that.isSendingMessage = false
                }, 100);
            });

            // that.$parent.sendMsgToTradesman(that.msg, that.tradesmanInfo.username);
            // that.$parent.addRoster({name:that.tradesmanInfo.username, username:that.tradesmanInfo.im_username});
            // 获取历史数据 - 不应该在这，测试用
            // return;
            // let name = that.tradesmanInfo.im_username;
            // let isGroup = false;
            // let success = function (msgs) {
            //     console.log('历史消息：',msgs)
            //     if (msgs.length === 0) {
            //         console.log("已无更多数据");
            //     }
            // };
        },
        // 获取历史
        getHistory(isLoad) {
            var that = this;

            that.sendDingzhiInfo();
            that.$parent.getHistoryMessage({ name: that.tradesmanInfo.im_username, isGroup: false }, function(msgs) {
                if (isLoad) {
                    setTimeout(function() {
                        that.msgList = msgs.concat(that.msgList);
                        that.setTodayFirstMessage()
                        that.isLoading = false;
                    }, 200);
                } else {
                    that.msgList = msgs.concat(that.msgList);
                    that.setTodayFirstMessage()
                    setTimeout(function() {
                        $(window).scrollTop($('body').height());
                    }, 100);
                }

                localStorage.setItem('msgHistory', JSON.stringify(that.msgList));
                for (var i in that.msgList) {
                    that.$parent.updateHistoryList({ to_user: that.tradesmanInfo.im_username, time: that.msgList[i].time });
                }
            });
            setTimeout(function() {
                if (isLoad) {
                    that.isLoading = false;
                }
            }, 3000);
        },
        // 发送定制消息
        sendDingzhiInfo() {
            if (this.dingzhiId == null || this.dingzhiId == undefined || this.dingzhiId == '') {
                return;
            }
            // 检查是否已经发送过定制消息
            var senddingzhiArr = window.localStorage.getItem('senddingzhiArr');
            if (senddingzhiArr != null) {
                senddingzhiArr = JSON.parse(senddingzhiArr);
                for (var i = 0; i < senddingzhiArr.length; i++) {
                    if (this.tradesmanInfo.tradesmans.id == senddingzhiArr[i].tradesmanid && this.dingzhiId == senddingzhiArr[i].dingzhiId) {
                        // 监测到已发送定制消息，组织发送
                        return;
                    }
                }
            }
            var that = this;
            var params = {
                token: that.$store.getters.token,
                id: this.dingzhiId
            };
            this.$api.dingzhi.specialDetail(params).then(res => {
                if (res.code == 200) {
                    // that.dingzhiId = null;
                    var detail = res.result;
                    var album = res.result.album;
                    var imglist = album != null ? album.split(',') : ['/m/statics/images/default_touxiang.png'];
                    var image = '';
                    if (imglist.length > 0) {
                        image = imglist[0];
                    }
                    if (
                        (detail.title == null || detail.title == undefined || detail.title == '') &&
                        (detail.describe == null || detail.describe == undefined || detail.describe == '') &&
                        (album == null || album == undefined || album == '')
                    ) {
                        return;
                    }
                    var data = { title: detail.title, detail: detail.describe, image: image, url: 'dingzhi/formDetail?id=' + this.dingzhiId };
                    var dingzhi = JSON.stringify(data);
                    dingzhi = 'dingzhi://' + dingzhi;
                    that.sendMsg(dingzhi);
                    // return;
                    if (senddingzhiArr != null) {
                        // senddingzhiArr = JSON.parse(senddingzhiArr);
                        senddingzhiArr.push({
                            tradesmanid: that.tradesmanInfo.tradesmans.id,
                            dingzhiId: that.dingzhiId
                        });
                        window.localStorage.setItem('senddingzhiArr', JSON.stringify(senddingzhiArr));
                    } else {
                        // senddingzhiArr = JSON.parse(senddingzhiArr);
                        senddingzhiArr = [];
                        senddingzhiArr.push({
                            tradesmanid: that.tradesmanInfo.tradesmans.id,
                            dingzhiId: that.dingzhiId
                        });
                        window.localStorage.setItem('senddingzhiArr', JSON.stringify(senddingzhiArr));
                    }
                }
            });
        },
        setTodayFirstMessage() {
            if (this.tradesmanInfo.tradesmans) {
                for (let i = 0; i < this.msgList.length; i++) {
                    const item = this.msgList[i];
                    console.log(item)
                    if (this.mine.userId == item.from) {                    
                        if ( this.formateDate(item.time).indexOf('今天') > -1) {
                            console.log('item:',item)
                            item.isTodayFirst = true
                            break
                        }
                        
                    }
                }
            }
            
        },
        // 下拉加载更多历史
        onLoadMoreHistory() {
            var that = this;
            that.getHistory(true);
        },
        // 格式化日期
        formateDate(time) {
            let dates = new Date(parseInt(time));
            var fDate =
                dates.getFullYear() +
                '/' +
                (dates.getMonth() + 1 < 10 ? '0' + (dates.getMonth() + 1) : dates.getMonth() + 1) +
                '/' +
                (dates.getDate() < 10 ? '0' + dates.getDate() : dates.getDate());
            var fTime =
                (dates.getHours() < 10 ? '0' + dates.getHours() : dates.getHours()) +
                ':' +
                (dates.getMinutes() < 10 ? '0' + dates.getMinutes() : dates.getMinutes()) +
                ':' +
                (dates.getSeconds() < 10 ? '0' + dates.getSeconds() : dates.getSeconds());

            // 获取今天
            var today = new Date();
            var tDate = today.getFullYear() + '/' + (today.getMonth() + 1) + '/' + today.getDate();
            if (new Date(fDate + ' 00:00:00').getTime() == new Date(tDate + ' 00:00:00').getTime()) {
                return '今天 ' + fTime;
            } else if (new Date(fDate + ' 00:00:00').getTime() == new Date(tDate + ' 00:00:00').getTime() - 24 * 3600 * 1000) {
                return '昨天 ' + fTime;
            } else {
                return fDate + ' ' + fTime;
            }
        },
        // 定制信息格式化
        isdingzhi(item) {
            var msg = item.data;
            if (msg && msg != undefined && msg != '') {
                msg = typeof msg == 'Object' || typeof msg == 'object' ? JSON.stringify(msg) : msg;
                if (msg.indexOf('dingzhi://') > -1) {
                    // if ( msg.indexOf('"') > -1 ) {
                    //     msg = msg.substring(0,msg.length-1);
                    // }
                    msg = msg.replace(/(^\"*)|(\"*$)/g, '');
                    // return;
                    if (msg.indexOf('{') > -1) {
                        msg = msg.substr(msg.indexOf('{'));
                    }
                    msg = msg.replace(/\\\"/g, '"');

                    // return;
                    msg = JSON.parse(msg);
                    return (
                        '<a href="' +
                        this.$publicData.clientUrl +
                        '/' +
                        msg.url +
                        '" class="dingzhi_tpl clearfix">' +
                        '<div class="d_msg">' +
                        '<h3>' +
                        msg.title +
                        '</h3>' +
                        '<p>' +
                        msg.detail +
                        '</p>' +
                        '</div>' +
                        '<img src="' +
                        msg.image +
                        '" class="d_thumb" />' +
                        '</a>'
                    );
                } else if (msg.indexOf('dingzhiOrder://') > -1) {
                    msg = msg.replace(/(^\"*)|(\"*$)/g, '');
                    var arr = msg.split('://');
                    var url = this.$publicData.clientUrl + '/dingzhi/form/touser?' + arr[1];
                    return '<a href="' + url + '" class="dingzhi_form">' + '<img src="' + this.publicPath + 'statics/images/dingzhi/form_tu.png' + '" class="form_tu" />' + '</a>';
                } else if (msg.indexOf('tradesmanDingzhi://') > -1) {

                    msg = msg.replace(/(^\"*)|(\"*$)/g, '');
                    if (msg.indexOf('{') > -1) {
                        msg = msg.substr(msg.indexOf('{'));
                    }
                    msg = msg.replace(/\\\"/g, '"');

                    msg = JSON.parse(msg);
                    return (
                        '<a href="' +
                        this.$publicData.clientUrl +
                        '/' +
                        msg.url +
                        '" class="dingzhi_tpl clearfix">' +
                        '<div class="d_msg">' +
                        '<h3>' +
                        msg.title +
                        '</h3>' +
                        '<p>' +
                        (msg.detail?msg.detail:'') +
                        '</p>' +
                        '</div>' +
                        '<img src="' +
                        msg.image +
                        '" class="d_thumb" />' +
                        '</a>'
                    );
                } else {
                    return '<div class="xiaoxi" >' + msg + '</div>';
                }
            } else {
                // 解析图片
                var url = item.url;
                if (url == null || url == undefined || url != '') {
                    return ''
                }
                if (url.indexOf('/upload/') > -1) {
                    url = this.$publicData.imgPath + '/upload/' + url.match(/\/upload\/(\S*)/)[1];
                    return '<div class="xiaoxi" ><img src="' + url + '" class="form_tu" /></div>';
                }
                return '<div class="xiaoxi" ><img src="' + url + '" class="form_tu" /></div>';
            }
        },
        // 发送定制表单
        sendDingzhiForm() {
            var form = 'dingzhiOrder://trade_uuid=' + this.mineUUID + '&touuid=' + this.uuid;
            this.sendMsg(form);
        },
        // 获取用户信息
        getUserInfo() {
            var that = this;
            var params = {
                token: that.$store.getters.token
            };
            that.$api.user.index(params).then(res => {
                if (res.code == 200) {
                    that.userRole = res.result.info.userrole;
                    that.mineUUID = res.result.info.uuid;
                }
            });
        },
        // 去获取匠人已发过的定制
        selectTradesmanDingzhi() {
            var that = this;
            that.$router.push({
                path: '/tradesman/dingzhi/self?is_send=1'
            });
        },
        // 发送匠人的定制
        sendTradesmanDingzhi() {
            var detail = this.tradesmanDingzhi;
            var images = detail.album ? detail.album.split(',') : [];
            var image = detail.album ? images[0] : this.$publicData.intangibleDefault;
            var data = { title: detail.title, detail: detail.descript ? detail.descript : '', image: image, url: 'dingzhi/detail?id=' + detail.id };
            var form = JSON.stringify(data);
            form = 'tradesmanDingzhi://' + form;
            this.sendMsg(form);
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.item_attention {
    width: 100%;
    text-align: center;
    font-size: 0.34rem;
    color: rgb(127, 127, 127);
}
.dingzhi_tpl {
    max-width: 4.85rem;
    height: 1.8rem;
    margin: 0.75rem 0.2rem 0 0.1rem;
    padding: 0.2rem;
    border: 1px solid #efefef;
    border-radius: 0.05rem;
    color: #666;
    background: #fff;
    display: flex;
}

.dingzhi_tpl .d_thumb {
    width: 1.4rem;
    height: 1.4rem;
    margin-left: 0.2rem;
    flex: 1;
}

.dingzhi_tpl .d_msg h3 {
    line-height: 1.5em;
    font-size: 0.32rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.dingzhi_tpl .d_msg p {
    line-height: 1.5em;
    margin-top: 0.1rem;
    font-size: 0.27rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
/* 定制按钮 */
.dingzhi_btns {
    width: 100%;
    height: 1rem;
    background: white;
    position: fixed;
    bottom: 1.2rem;
    padding: 0.25rem 0.52rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.dingzhi_btns .btn {
    width: 1.4rem;
    height: 0.53rem;
    border: 0.0134rem solid #333;
    border-radius: 0.26rem;
    text-align: center;
    line-height: 0.53rem;
    color: #333;
    font-size: 0.34rem;
}
.dingzhi_btns .btn.bigsize {
    width: auto;
    padding: 0 0.2rem;
    margin-left: 0.52rem;
}
/* 定制单 */
/deep/ .dingzhi_form {
    width: 3.98rem;
    height: 5.58rem;
    margin-top: 0.73rem;
    margin-left: 0.5rem;
    display: block;
}
/deep/ .form_tu {
    max-width: 3.98rem;
    max-height: 5.58rem;
}
</style>
